import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const supplierLocaleModule: LocaleModule = {
  name: "supplier",
  messages: { en: en, it: it },
};
